// 返回数字数组中的重复项
export function arrayDuplicate(arr: number[]) {
  const tmp: number[] = [];
  arr
    .concat()
    .sort()
    .sort(function (a, b): any {
      if (a == b && tmp.indexOf(a) === -1) tmp.push(a);
    });
  return tmp;
}

// 两位小数转为整数（乘100）
export function solveLargeNumber(v: number | string) {
  const n = String(Number(v));
  let res = 0;
  const l = String(n).split(".");
  if (l.length <= 1) {
    res = Number(n) * 100;
  } else if (l[1].length === 1) {
    res = Number(String(n).replace(/\./, "") + "0");
  } else if (l[1].length === 2) {
    res = Number(String(n).replace(/\./, ""));
  } else if (l[1].length > 2) {
    res = Math.ceil(Number(n) * 100);
  } else {
    res = Number(n) * 100;
  }
  return res;
}
